/* eslint func-style: "off" */
import moment from 'moment';
import { all, call, fork, put, select, takeLatest } from 'redux-saga/effects';
import {
  CREATE_DASHBOARD_LINK,
  createDashboardLinkBegan,
  createDashboardLinkSucceeded,
  createDashboardLinkFailed
} from './CreateDashboardLink.ducks';
import apiClient from 'helpers/apiClient';
import { convertDatePickerTimeToMoment, convertDatePickerTimeToApiTime } from 'helpers/timeFormat';
import isEmpty from 'lodash/isEmpty';

const _getFetchParams = (action) => {
  return (state) => {
    const { expiresIn, selectedStartDate, selectedEndDate, timeStartWindow } = state.CreateDashboardLink;
    const params = {
      campaignId: action.campaignId,
      createdBy: action.createdBy,
      name: action.dashboardName,
      type: 'dashboard',
      typeId: action.dashboardId,
      path: `/dashboard/${action.dashboardId}`,
      parameters: {}
    };
    if(timeStartWindow) {
      params.parameters = {
        time_window: timeStartWindow
      };
    } else if (!isEmpty(selectedStartDate) && !isEmpty(selectedEndDate)) {
      params.parameters = {
        start_time: selectedStartDate,
        end_time: selectedEndDate
      };
    }
    if (expiresIn.value > 0) {
      params.expiresAt = moment().add(expiresIn.value, 'days');
    }
    return params;
  };
};

function _getCreateDashboardLinkAnalytics() {
  return (state) => {
    const { expiresIn, selectedStartDate, selectedEndDate, timeStartWindow } = state.CreateDashboardLink;
    const { timezone } = state.AppUser.user;
    const startMoment = convertDatePickerTimeToMoment(selectedStartDate, timezone);
    const endMoment = convertDatePickerTimeToMoment(selectedEndDate, timezone).add(1, 'second');
    const startTime = convertDatePickerTimeToApiTime(selectedStartDate, timezone);
    const endTime = convertDatePickerTimeToApiTime(selectedEndDate, timezone);

    const analytics = {
      start_time: startTime, // ISO-8601
      end_time: endTime, // ISO-8601, vs. 'now'
      duration_in_days: endMoment.diff(startMoment, 'days', true), // provides fractional number
      is_now: selectedEndDate === 'now',
      expires: expiresIn.label,
    };
    if (timeStartWindow) {
      analytics.time_window = timeStartWindow; // eg. 'Last 7 days', 'Yesterday'
    }

    return analytics;
  };
}

export const createDashboardLink = function* (action) {
  try {
    const requestBody = yield select(_getFetchParams(action));
    const { campaignId } = requestBody;
    const fetchOptions = {
      method: 'POST',
      body: JSON.stringify(requestBody)
    };
    yield put(createDashboardLinkBegan());
    const payload = yield call(apiClient, `/api/campaigns/${campaignId}/sharedTokens`, fetchOptions);
    const analytics = yield select(_getCreateDashboardLinkAnalytics(action));
    yield put(createDashboardLinkSucceeded(payload, analytics));
  } catch (e) {
    yield put(createDashboardLinkFailed('Unable to create a Dashboard Link due to a server error.'));
  }
};

export const createDashboardLinkSaga = function* () {
  yield takeLatest( CREATE_DASHBOARD_LINK, createDashboardLink);
};

const sagas = function* () {
  yield all([
    fork(createDashboardLinkSaga)
  ]);
};

export default sagas;
export {
  _getFetchParams,
  _getCreateDashboardLinkAnalytics,
};
